import React, { ReactNode } from 'react'

type Props = {
    title: string
    children: ReactNode
}

const Section: React.FC<Props> = ({ title, children }) => {
    return (
        <div className="flex flex-col w-full h-fit p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] shadow-lg shadow-[#18181825]">
            <h2 className="mb-2 text-lg text-[#181818] dark:text-[#FFFFFF]">
                {title}
            </h2>
            {children}
        </div>
    )
}

export default Section
